import { Component } from '@angular/core';
import { Stitch } from 'mongodb-stitch-browser-sdk';
import { environment } from 'src/environments/environment';
import { VideoService } from './modules/student/services/video.service';
import { AllVideosDataService } from './core/service/AllVideosDataService';
import { UserService } from './modules/student/services/user.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'drbeen';


  constructor(private videoService : VideoService,private allVideoDataService : AllVideosDataService,
    private userService : UserService){
    Stitch.initializeDefaultAppClient(environment.stichApiKey);
   // console.log("Gettign Data from Server"+localStorage.getItem("all_videos"));
    //this.getAllVideosList();
    
    if(localStorage.getItem("all_videos") == null){
      console.log("Fetching Latest Videos");
      this.getAllVideosList();
    }else{
      console.log("Videos already offline");
    }

    this.getAllInstructorList();

  }




  getAllVideosList(){
   // console.log("getAllVideosList");
    let body = {"subject" : "All"};
    this.videoService.getAllVideosListInCategory(body).subscribe((resp : any) => {
      this.onVideoListSucess(resp);
      }, (err) => {
    // Unable to log in
        this.onVideosListError(err);    
    });
  }



  onVideoListSucess(resp : any){
    console.log("video success"+JSON.stringify(resp));
    //saving this response in browser
    localStorage.setItem("all_videos",JSON.stringify(resp));
    this.allVideoDataService.updateAllVideoList(resp);
    
  
  }

  onVideosListError(err : any){
    console.log("video error"+JSON.stringify(err));
  }


  getAllInstructorList(){
    // console.log("getAllVideosList");
    let body = {};
    this.userService.getAllInstructor(body).subscribe((resp : any) => {
      this.onInstructorListSuccess(resp);
      }, (err) => {
    // Unable to log in
        this.onInstructorListError(err);    
    });
  }

  onInstructorListSuccess(resp){
    console.log("instructor success");
    localStorage.setItem("all_instructor",JSON.stringify(resp));
  }

  onInstructorListError(err){

  }

}
